import script from "./jijia-introduce-src4-tips.vue?vue&type=script&lang=ts&setup=true"
export * from "./jijia-introduce-src4-tips.vue?vue&type=script&lang=ts&setup=true"

import "./jijia-introduce-src4-tips.vue?vue&type=style&index=0&id=8079b62e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8079b62e"]])

export default __exports__